<template>
  <div>
    <v-alert type="error">
      当前页面被标记为<b>开发中</b>，暂时无法实现功能，敬请期待。
    </v-alert>
    <v-row>
      <v-col cols="8">
        <v-card>
          <v-card-title>
            我的衣柜
            <v-spacer></v-spacer>
            <v-btn class="mr-2" rounded color="primary" dark href="//skin.makjust.com" target="_black">
              皮肤库
            </v-btn>
            <v-btn rounded color="primary" dark>
              上传皮肤
              <v-icon right>backup</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row v-if="myskins">
              <v-col v-for="(skin, i) in myskins" :key="`_SKINPAGE-USERSKINCRAD-${i}`" cols="4">
                <skincard :private="skin.private" :sname="skin.name" :up="skin.up" :sid="skin.sid" />
              </v-col>
            </v-row>
            <div v-else>
              <span>本来无一物，何处惹尘埃</span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card>
          <v-card-title>
            皮肤预览
            <v-spacer></v-spacer>
            <v-btn icon>
              <v-icon>directions_run</v-icon>
            </v-btn>
            <v-btn icon>
              <v-icon>play_arrow</v-icon>
            </v-btn>
            <v-btn icon>
              <v-icon>stop</v-icon>
            </v-btn>
            <v-btn icon>
              <v-icon>replay</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
              <v-skeleton-loader class="my-3" type="image"></v-skeleton-loader>
          </v-card-text>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed color="primary">重置皮肤</v-btn>
          </v-card-actions>
        </v-card>
        <v-card class="mt-4">
          <v-card-title>使用历史</v-card-title>
          <v-card-subtitle>仅在本地保存历史</v-card-subtitle>
          <v-card-text>
            <v-skeleton-loader class="my-3" type="text"></v-skeleton-loader>
            <v-skeleton-loader class="my-3" type="text"></v-skeleton-loader>
            <v-skeleton-loader class="my-3" type="text"></v-skeleton-loader>
            <v-skeleton-loader class="my-3" type="text"></v-skeleton-loader>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "SKINPAGE",
  data() {
    return {
        myskins: false
        // [
        //     {
        //         name: '香风智乃',
        //         private: true,
        //         up: 'TESTq1',
        //         sid: 32001
        //     },
        // ]
    };
  },
  components: {
    skincard: () => import("../../components/userSkinCrad")
  }
};
</script>